/* tslint:disable */
/* eslint-disable */
/**
 * Account App Tier Operations API
 * APIs for the Account App Tier Microservice
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PhoneType = {
    Home: 'HOME',
    Mobile: 'MOBILE',
    Business: 'BUSINESS'
} as const;
export type PhoneType = typeof PhoneType[keyof typeof PhoneType];


export function PhoneTypeFromJSON(json: any): PhoneType {
    return PhoneTypeFromJSONTyped(json, false);
}

export function PhoneTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhoneType {
    return json as PhoneType;
}

export function PhoneTypeToJSON(value?: PhoneType | null): any {
    return value as any;
}

